import React = require('react');
import { AdmiralCardAnswer } from '../../../Components/AdmiralCardAnswer';
import { map } from 'lodash';
import * as Commonmark from 'react-commonmark';
import { Field } from 'redux-form';
import { isRequired } from '../../../../../../util/validators';
import { ButtonAsRadio } from '../../../../../../components/ButtonRadioStyle';

interface IMedicalQuestionCardProps {
  medicalDeclaration: any[];

  renderDefinition(name: string, useProvidedString?: boolean): any;
}

export const MedicalQuestionCards = ({ medicalDeclaration, renderDefinition }: IMedicalQuestionCardProps) => {

  const content = (item) => {
    return (
      <div style={{ display: 'flex' }}>
        <Commonmark source={item.content}/>
        <div>
          {renderDefinition(item.true_key, item.help_text)}
        </div>
      </div>
    )
  }

  const renderButtons = (key) => {
    return (
      <>
        <div className={'button-container'}>
          <div className={'box--half'}>
            <Field
              name={`medicalDeclaration[${key}].answer`}
              simpleValue={true}
              className={'admiral-yes-no-answer-btn'}
              secondaryClass={'admiral-yes-no-answer-btn selected'}
              selectedText={'YES'}
              unSelectedText={'YES'}
              isBlock={true}
              validate={[isRequired]}
              component={ButtonAsRadio}
            />
          </div>
          <div className={'box--half'}>
            <Field
              name={`medicalDeclaration[${key}].answer`}
              simpleValue={false}
              className={'admiral-yes-no-answer-btn'}
              secondaryClass={'admiral-yes-no-answer-btn selected'}
              selectedText={'NO'}
              unSelectedText={'NO'}
              isBlock={true}
              validate={[isRequired]}
              component={ButtonAsRadio}
            />
          </div>
        </div>
      </>
    )
  }

  return map(medicalDeclaration, (value, key) => {
    return (
      <>
        <AdmiralCardAnswer hideHeader={true}>{content(value)}</AdmiralCardAnswer>
        <div style={{ backgroundColor: '#FFFFFF' }}>
          {renderButtons(key)}
        </div>
      </>
    )
  })
}
